import SectionInstagram from './SectionInstagram';
export default SectionInstagram;
